import {Badge, Box, List, Typography} from '@mui/material'
import {ChatBubbleOutline} from '@mui/icons-material'
import {Fragment} from 'react'
import {useLocation, useParams} from 'react-router-dom'
import {useContent} from '../../../logic'
import {useGetOrder} from '../../../logic/useApiQuery'
import {getNotificationsInfo} from '../../../utils'
import {LoadingScreen} from '../../shared'
import {MessageListItem} from './MessageListItem'

export function MessagingPage() {
  const {closingId} = useParams()
  const {search} = useLocation()
  const uiContent = useContent()
  const {data: globalOrderData, isLoading} = useGetOrder(closingId ?? '', search ?? '')

  if (isLoading || !globalOrderData) return <LoadingScreen/>

  const notificationsInfo = getNotificationsInfo(
    globalOrderData.Notifications,
    uiContent,
    globalOrderData,
  )
  const {messages, unreadMessages} = notificationsInfo
  const unreadCount = unreadMessages.length

  return (
    <Box sx={{width: '100%'}}>
      <Box sx={{bgcolor: 'white', borderRadius: '16px', overflow: 'hidden'}}>
        <Box sx={{display: 'flex', alignItems: 'center', gap: 1.5, px: 2, py: 1.5, borderBottom: '1px solid #ddd'}}>
          <Badge badgeContent={unreadCount} color="primary">
            <ChatBubbleOutline sx={{color: 'primary.main'}}/>
          </Badge>
          <Typography variant="h5" sx={{fontWeight: 500}}>
            Messages
          </Typography>
        </Box>
        {messages.length === 0 ? (
          <Box sx={{p: 2, textAlign: 'center'}}>
            <Typography color="text.secondary">No messages</Typography>
          </Box>
        ) : (
          <List disablePadding>
            {messages.map((notification, index) => (
              <Fragment key={notification.NotificationId}>
                <MessageListItem
                  notification={notification}
                  isLast={index === messages.length - 1}
                />
              </Fragment>
            ))}
          </List>
        )}
      </Box>
    </Box>
  )
}
